import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { CSidebar, CSidebarNav, CNavItem, CNavLink } from "@coreui/react";
import "../Sidebar/Sidebar.css";
import Swal from "sweetalert2";
import { getUserById } from "../Component/api/api";
import matchblack from "../assets/images/your-matches-black.png";
import matchred from "../assets/images/your-matches-red.png";
import connectionred from "../assets/images/your-connections-red.png";
import connectionblack from "../assets/images/your-connections-black.png";
import messageblack from "../assets/images/messages-black.png";
import messagered from "../assets/images/messages-red.png";
import editblack from "../assets/images/edit-profile-black.png";
import editRed from "../assets/images/edit-profile-red.png";
import counsellingblack from "../assets/images/counselling-black.png";
import counsellingred from "../assets/images/counselling-red.png";
import paymentred from "../assets/images/payment-history-red.png";
import paymentblack from "../assets/images/payment-history-black.png";
import helpred from "../assets/images/help-&-support-red.png";
import helpblack from "../assets/images/help-&-support-black.png";
import logoutblack from "../assets/images/log-out-black.png";
import subscriptionred from "../assets/images/subscription-red.png";
import subscriptionblack from "../assets/images/subscription-black.png";
import blogteal from "../assets/images/blog-teal-colour.png";
import blogblack from "../assets/images/blog-black-colour.png";
import { FiBell } from "react-icons/fi";
import aboutbanners from "../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';

// import logoutred from "../assets/images/log-out-red.png";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [userData, setUserdata] = useState(null);
  useEffect(() => {
    const user = localStorage.getItem("currentUser");
    if (!user) {
      navigate("/Login", { replace: true });
    }
  }, []);
  useEffect(() => {
    const getUser = async () => {
      const storedUser = JSON.parse(localStorage.getItem("currentUser"));
      const _id = storedUser?.id || storedUser?._id;
      const res = await getUserById({ user_id: _id });
      console.log("getUserbyId_call_in_Sidebar", res);
      setUserdata(res);
      // setShowUploadButton(res?.data?.more_images?.length < MAX_IMAGES);
    };
    getUser();
  }, []);

  // const handleDropdownClick = (option) => {
  //   if (option === "sendSupport") {
  //     navigate("/Sidebar/send-support");
  //   } else if (option === "raisePayment") {
  //     navigate("/Sidebar/raise-payment");
  //   }
  // };

  useEffect(() => {
    if (location.pathname === "/Sidebar") {
      navigate("/Sidebar/home");
    }
  }, [location, navigate]);

  const isActiveRoute = (route) => location.pathname === route;
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e04a48",
      cancelButtonColor: "#058787",
      confirmButtonText: "Yes, Logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("currentUser");
        window.dispatchEvent(new Event("userLoggedOut"));
        // navigate("/Login");
        navigate("/Login", { replace: true });
      }
    });
  };
  return (
    <div>
      <div className="dadhbrdbnnr"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}>

      </div>
      <div className="mainallpages" style={{}}>
        <CSidebar
          style={
            {
              // backgroundColor: "#000",
            }
          }
        >
          <CSidebarNav>
            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/home"
                className={`sidenav-link ${isActiveRoute("/Sidebar/home") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilHome} className="sidecustom-icon-size" /> */}
                <img
                  src={isActiveRoute("/Sidebar/home") ? matchred : matchblack}
                  alt="Matches"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Your Matches</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/profile"
                className={`sidenav-link ${isActiveRoute("/Sidebar/profile") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilUser} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/profile")
                      ? connectionred
                      : connectionblack
                  }
                  alt="Connections"
                  className="sidecustom-icon-size"
                />

                <span className="sidelink-text">Your Connections</span>
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/Messages"
                className={`sidenav-link ${isActiveRoute("/Sidebar/Messages") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilChatBubble} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/Messages")
                      ? messagered
                      : messageblack
                  }
                  alt="Messages"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Messages</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/EditProfile"
                className={`sidenav-link ${isActiveRoute("/Sidebar/EditProfile") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilPencil} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/EditProfile") ? editRed : editblack
                  }
                  alt="Edit Profile"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Edit Profile</span>
              </CNavLink>
            </CNavItem>
            {/* Blog */}

            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/Consult"
                className={`sidenav-link ${isActiveRoute("/Sidebar/Consult") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilSpeech} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/Consult")
                      ? counsellingred
                      : counsellingblack
                  }
                  alt="Counselling"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Counselling</span>
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/Subscription"
                className={`sidenav-link ${isActiveRoute("/Sidebar/Subscription") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilSpeech} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/Subscription")
                      ? subscriptionred
                      : subscriptionblack
                  }
                  alt="Subscription"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Subscription</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/PaymentHistory"
                className={`sidenav-link ${isActiveRoute("/Sidebar/PaymentHistory") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilCreditCard} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/PaymentHistory")
                      ? paymentred
                      : paymentblack
                  }
                  alt="Payment"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Payment History</span>
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/notification"
                className={`sidenav-link ${isActiveRoute("/Sidebar/notification") ? "active-link" : ""
                  }`}
              >
                <FiBell
                  className="sidecustom-icon-size"
                  color={
                    isActiveRoute("/Sidebar/notification") ? "#058787" : "#000"
                  }
                  size={20}
                />
                <span className="sidelink-text">Notification</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                to="/Sidebar/helpandsupport"
                className={`sidenav-link ${isActiveRoute("/Sidebar/helpandsupport") ? "active-link" : ""
                  }`}
              >
                {/* <CIcon icon={cilLifeRing} className="sidecustom-icon-size" /> */}
                <img
                  src={
                    isActiveRoute("/Sidebar/helpandsupport")
                      ? helpred
                      : helpblack
                  }
                  alt="Help"
                  className="sidecustom-icon-size"
                />
                <span className="sidelink-text">Help and Support</span>
              </CNavLink>
            </CNavItem>

            <CNavItem>
              <CNavLink
                as={Link}
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
                className="sidenav-link"
              >
                {/* <CIcon
                  icon={cilAccountLogout}
                  className="sidecustom-icon-size"
                /> */}
                <img
                  src={logoutblack}
                  alt="Logout"
                  className="sidecustom-icon-size"
                />

                <span className="sidelink-text">Logout</span>
              </CNavLink>
            </CNavItem>
          </CSidebarNav>
        </CSidebar>
        <div className="mainpagesss" style={{}}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
